/* =========================================================================
   Amavil Berberina landing — behaviour (all scoped to .cpl-* only)
   NO cart logic here. The buy area uses the theme's NATIVE <product-form>
   (product-form.js) so Kaching Bundles/Subscriptions hook it and the native
   cart drawer opens. This file only does gallery, accordions, carousels,
   the sticky bar (scroll-only + price mirror) and media preload.
   ========================================================================= */
(function () {
  'use strict';

  /* ---------- Product gallery: arrows + swipe + thumbnails ---------- */
  function initGallery(root) {
    (root || document).querySelectorAll('[data-cpl-gallery]').forEach(function (g) {
      if (g.__cplInit) return; g.__cplInit = true;
      var mainImg = g.querySelector('[data-cpl-gallery-main]');
      var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-cpl-thumb]'));
      if (!mainImg || !thumbs.length) return;
      var list = thumbs.map(function (t) { return t.getAttribute('data-full'); });
      var idx = 0;
      function setActive(i) {
        idx = (i + list.length) % list.length;
        var src = list[idx];
        if (src) { mainImg.src = src; mainImg.setAttribute('srcset', ''); }
        thumbs.forEach(function (t, ti) { t.classList.toggle('is-active', ti === idx); });
        var at = thumbs[idx];
        if (at && at.scrollIntoView) { try { at.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' }); } catch (e) {} }
      }
      g.addEventListener('click', function (e) {
        var thumb = e.target.closest('[data-cpl-thumb]');
        if (thumb) { var ti = thumbs.indexOf(thumb); if (ti >= 0) setActive(ti); return; }
        if (e.target.closest('[data-cpl-gallery-prev]')) { setActive(idx - 1); return; }
        if (e.target.closest('[data-cpl-gallery-next]')) { setActive(idx + 1); return; }
      });
      var stage = g.querySelector('[data-cpl-gallery-stage]');
      if (stage && list.length > 1) {
        var sx = null, sy = null;
        stage.addEventListener('touchstart', function (e) { var t = e.changedTouches[0]; sx = t.clientX; sy = t.clientY; }, { passive: true });
        stage.addEventListener('touchend', function (e) {
          if (sx === null) return; var t = e.changedTouches[0];
          var dx = t.clientX - sx, dy = t.clientY - sy;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { if (dx < 0) setActive(idx + 1); else setActive(idx - 1); }
          sx = null; sy = null;
        }, { passive: true });
      }
      thumbs.forEach(function (t, ti) { t.classList.toggle('is-active', ti === 0); });
    });
  }

  /* ---------- Accordions (product info + faq) ---------- */
  function onAccordionClick(e) {
    var btn = e.target.closest('[data-cpl-acc-btn]');
    if (!btn) return;
    var item = btn.closest('[data-cpl-acc]');
    if (!item) return;
    var group = item.getAttribute('data-cpl-acc-group');
    var open = item.classList.contains('is-open');
    if (group) document.querySelectorAll('[data-cpl-acc][data-cpl-acc-group="' + group + '"]').forEach(function (a) { a.classList.remove('is-open'); });
    item.classList.toggle('is-open', !open);
  }

  /* ---------- Horizontal rail carousels (photo / text) ---------- */
  function initRails(root) {
    (root || document).querySelectorAll('[data-cpl-rail]').forEach(function (wrap) {
      if (wrap.__cplInit) return; wrap.__cplInit = true;
      var track = wrap.querySelector('[data-cpl-rail-track]');
      if (!track) return;
      function step(dir) {
        var w = track.clientWidth * (window.innerWidth >= 840 ? 0.34 : 0.87);
        track.scrollBy({ left: dir * w, behavior: 'smooth' });
      }
      wrap.addEventListener('click', function (e) {
        if (e.target.closest('[data-cpl-rail-prev]')) step(-1);
        else if (e.target.closest('[data-cpl-rail-next]')) step(1);
      });
      var dots = Array.prototype.slice.call(wrap.querySelectorAll('[data-cpl-rail-dot]'));
      if (dots.length) {
        track.addEventListener('scroll', function () {
          var max = track.scrollWidth - track.clientWidth;
          var p = max > 0 ? track.scrollLeft / max : 0;
          var a = Math.min(dots.length - 1, Math.round(p * (dots.length - 1)));
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === a); });
        }, { passive: true });
      }
    });
  }

  /* ---------- Sticky CTA: hidden on load, show mid-scroll, mirror price,
                click = scroll to buy (NEVER adds to cart) ---------- */
  function initSticky(root) {
    (root || document).querySelectorAll('[data-cpl-sticky]').forEach(function (bar) {
      if (bar.__cplInit) return; bar.__cplInit = true;
      var buy = document.getElementById('cpl-zona-compra');
      var btn = bar.querySelector('[data-cpl-sticky-btn]');
      var mirror = bar.querySelector('[data-cpl-sticky-price]');
      function onScroll() {
        if (!buy) return;
        var past = window.scrollY > (buy.offsetTop + buy.offsetHeight - 200);
        bar.classList.toggle('is-visible', past);
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
      if (btn) btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (buy) window.scrollTo({ top: buy.getBoundingClientRect().top + window.scrollY - 90, behavior: 'smooth' });
      });
      var source = document.querySelector('[data-cpl-atc] [data-cpl-atc-label]') || document.querySelector('[data-cpl-atc] span');
      if (mirror && source) {
        var sync = function () { mirror.textContent = source.textContent.trim(); };
        sync();
        try { new MutationObserver(sync).observe(source, { childList: true, characterData: true, subtree: true }); } catch (e) {}
      }
    });
  }

  /* ---------- Media in custom sections: load with the page ---------- */
  function initVideos(root) {
    (root || document).querySelectorAll('video.cpl-video, #amavil-video-reviews video.amavil-video').forEach(function (v) {
      try { if (v.getAttribute('preload') !== 'auto') { v.setAttribute('preload', 'auto'); v.preload = 'auto'; v.load(); } } catch (e) {}
    });
  }

  function boot(root) {
    initGallery(root);
    initRails(root);
    initSticky(root);
    initVideos(root);
  }

  if (!window.__cplDelegation) {
    window.__cplDelegation = true;
    document.addEventListener('click', onAccordionClick);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();